













import {Component, Prop, Vue} from "vue-property-decorator";
import {RouterStore} from '@/interfaces/store-interfaces/router-store.interface';
import TextBox from "@/components/TextBox.vue";

@Component({
  components: {
    TextBox
  }
})

export default class HeroBox extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() title: string;
  @Prop() text: string;
  @Prop() image: string;
}
